module.exports = "/assets/d863bb31c5f2e66aaa1e9f185a60769e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VZ.png
// module id = 1944
// module chunks = 0